module.exports = __webpack_public_path__ + "img/logo.07dc18d3.png";